import styled from 'styled-components';

import Jumbotron from 'components/shared/ai/Jumbotron';
import colors from 'styles/theme/colors';
import { Label, LabelBold } from 'styles/typography';
import AISparkleIcon from 'svg/AISparkleIcon';
import ChevronRightBold from 'svg/ChevronRightBold';

type ReferralSummaryLauncherProps = {
  fileCount?: number;
  isSummarized?: boolean;
  onLaunch?: () => void;
} & React.PropsWithChildren;

export default function ReferralSummaryLauncher({
  fileCount = 1,
  isSummarized = false,
  onLaunch = () => {},
}: ReferralSummaryLauncherProps) {
  return (
    <StyledJumbotron data-cy='referralSummaryBanner'>
      <HeaderContainer>
        <TitleContainer>
          <AISparkleIcon width={14} height={14} />
          <HeaderText>Referral Summary</HeaderText>
        </TitleContainer>
        <TitleContainer>
          <Label>
            <LabelBold>
              {fileCount} file{fileCount === 1 ? '' : 's'}
            </LabelBold>{' '}
            {fileCount === 1 ? 'is' : 'are'} available for referral summarization
          </Label>
        </TitleContainer>
      </HeaderContainer>
      <ActionContainer onClick={onLaunch}>
        <ActionButton data-cy='summarizeReferralFiles'>
          {isSummarized ? 'View Summary' : 'View and Summarize Files'}
        </ActionButton>
        <StyledChevronRightBold width={10} height={10} fill={colors.black} />
      </ActionContainer>
    </StyledJumbotron>
  );
}

const StyledJumbotron = styled(Jumbotron)`
  flex-direction: row;
  justify-content: space-between;
  padding: 24px;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const HeaderText = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0.2px;

  color: #5e42e1;
`;

const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 24px;
  cursor: pointer;
`;

const ActionButton = styled.button`
  all: unset;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  text-align: right;
  letter-spacing: 0.2px;
  text-decoration-line: underline;

  color: #5e42e1;
`;

const StyledChevronRightBold = styled(ChevronRightBold)`
  position: relative;
  top: 1px;
`;
